import { Check } from "lucide-react";
import type { CheckoutStep } from "./useCheckoutFlow";

// Header rendered inside each Accordion trigger: numbered eyebrow,
// brand-black step title, and a state pill on the right.
//
// Status pill copy maps directly to the customer's mental model:
//   - "Complete"    — section's data is locked in
//   - "Required"    — not started, next up
//   - "Coming up"   — locked, an earlier section is still open
//   - "Optional"    — currently unused; reserved for future steps
export function SectionHeader({
  number,
  step
}: {
  number: number;
  step: CheckoutStep;
}): JSX.Element {
  return (
    <div className="flex flex-1 items-center gap-4 text-left">
      <span className="grid h-7 w-7 flex-none place-items-center rounded-full bg-flag-navy text-xs font-semibold text-brand-white">
        {step.complete ? <Check aria-hidden="true" className="h-3.5 w-3.5" /> : number}
      </span>
      <div className="flex-1">
        <p className="text-xs font-semibold uppercase tracking-[0.15em] text-brand-red">
          Step {number}
        </p>
        <p className="text-base font-semibold text-brand-black">{step.title}</p>
      </div>
      <StatusPill step={step} />
    </div>
  );
}

function StatusPill({ step }: { step: CheckoutStep }): JSX.Element {
  if (step.complete) {
    return (
      <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700">
        Complete
      </span>
    );
  }
  if (!step.unlocked) {
    return (
      <span className="rounded-full bg-zinc-100 px-2.5 py-1 text-xs font-medium text-zinc-500">
        Coming up
      </span>
    );
  }
  return (
    <span className="rounded-full bg-brand-red/10 px-2.5 py-1 text-xs font-medium text-brand-red">
      Required
    </span>
  );
}
